import React from 'react';
import {
    Header,
    Footer,
} from '../../components'
import {Redirect, Route, Switch} from "react-router-dom";
import {mainPrivateRoutes, mainPublicRoutes, RouteNames} from "../../router";
import ConsentModal from '../../components/ConsentModal';
import { useConsentCheck } from '../../hooks/useConsentCheck';
import { useTypedSelector } from '../../hooks/useTypedSelector';

const MainPage: React.FC = () => {

    const auth = localStorage.getItem("token")

    //const auth = true;//localStorage.getItem("token")
    
    // Получаем информацию о пациенте для отображения ФИО в модальном окне
    const { patient } = useTypedSelector(state => state.patientState);
    
    // Проверяем необходимость показа модального окна согласий
    const { showModal, loading, consentTypesInfo, handleModalClose } = useConsentCheck();
    
    // Формируем ФИО пациента для модального окна
    const patientFio = patient 
        ? `${patient.lastName || ''} ${patient.firstName || ''} ${patient.fatherName || ''}`.trim()
        : 'Пациент';

    return (
        <div className={'page'}>
            <Header/>
            {/* Модальное окно согласий показывается только если пользователь авторизован */}
            {auth && showModal && !loading && (
                <ConsentModal 
                    open={showModal} 
                    onClose={handleModalClose}
                    patientFio={patientFio}
                    consentTypesInfo={consentTypesInfo}
                />
            )}
            <div className={'page-body'}>
                {
                    auth ? (
                        <Switch>
                            {mainPrivateRoutes.map((route) => (
                                <Route
                                    key={route.path}
                                    path={route.path}
                                    exact={route.exact}
                                    component={route.component}
                                />
                            ))}
                            <Redirect to={RouteNames.PERSONAL_CABINET}/>
                        </Switch>
                    ) : (
                        <Switch>
                            {mainPublicRoutes.map((route) => (
                                <Route
                                    key={route.path}
                                    path={route.path}
                                    exact={route.exact}
                                    component={route.component}
                                />
                            ))}
                            <Redirect to={RouteNames.SIGNIN}/>
                        </Switch>
                    )
                }
            </div>
            <Footer/>
        </div>
    )
}

export default MainPage;